"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var API_BASE = 'contacts/v1/segment-ui/all';
var DEFAULT_OPTIONS = {
  count: 10000,
  direction: 'ASC',
  offset: 0,
  sortBy: 'LIST_NAME'
};

var ContactListsAPI =
/*#__PURE__*/
function () {
  function ContactListsAPI() {
    (0, _classCallCheck2.default)(this, ContactListsAPI);
  }

  (0, _createClass2.default)(ContactListsAPI, null, [{
    key: "getLists",
    value: function getLists() {
      return _apiClient.default.get(API_BASE, {
        query: (0, _extends2.default)({}, DEFAULT_OPTIONS)
      });
    }
  }]);
  return ContactListsAPI;
}();

exports.default = ContactListsAPI;
module.exports = exports.default;